import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { useRollbar } from '@rollbar/react'

import { setProject } from '../../../obj/pscState'

import useGncHistory from '../../../hooks/useGncHistory'

const SaveButton = forwardRef(function SaveButton(props, ref) {
    // { buttonVariant, spinnerActive, label, onClick, onError, visible }
    const buttonVariant = props.buttonVariant
    const spinnerActive = props.spinnerActive
    const label = props.label
    const onClick = props.onClick
    const onError = props.onError
    const visible = props.visible

    const rollbar = useRollbar()
    const dispatch = useDispatch()
    const location = useLocation()

    const {
        goBack,
        replaceCurrentPath,
    } = useGncHistory()

    useImperativeHandle(ref, () => {
        return {
            submit(actionProps) {
                submit(actionProps);
            },
        };
    }, []);
    
    const submit = (actionProps) => {
        const objType = actionProps.objType
        const objID = actionProps.objID
        const data = actionProps.data
        const successCallback = actionProps.successCallback
        const navigateOverride = actionProps.navigateOverride
        const url = actionProps.url || '/v0/' + objType + ( isNaN(objID) ? '' : '/' + objID )

        fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify( data )
        }).then(response => {
            if (!response.ok) throw response
            return response.json()
        }).then(async json => {
            if( json.result && json.result.id ) {
                let path = location.pathname.replace(/\/new$/, "/"+json.result.id)
                if( path !== location.pathname ) {
                    replaceCurrentPath(path)
                }
            }

            if( successCallback ) {
                await successCallback(json)
            }
            if( navigateOverride ) {
                navigateOverride(json)
            } else {
                goBack()
            }
        }).catch(error => {
            console.log("SaveButton: catch error", error)
            const contentType = error.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                error.json().then(responseText => {
                    rollbar?.error?.("SaveButton: error message: " + responseText.error)
                    onError({message: responseText.error})
                })
            } else {
                error.text().then(responseText => {
                    rollbar?.error?.("SaveButton: error message: " + responseText)
                    onError({message: responseText})
                })
            }
        })
    }
    
    const handleOnClick = (e) => {
        if(e) {
            e.preventDefault()
        }

        const current = e.currentTarget
        const form = current.closest('form')
        if (!form.checkValidity()) {
            // I thought we'd want to scroll to the top, but according to https://trello.com/c/r5tkfO2K/158-report-type-save-when-unpopulated-fields
            // that messes up the flow.
            //window.scrollTo(0, 0)
            
            // Let the browser show native validation messages
            form.reportValidity()
            return
        }
        const actionProps = onClick()
        if( actionProps === null ) {
            return
        }
        submit(actionProps)
    }
    
    if( !visible ) {
        return <span/>
    }

    const className = 'btn btn-mr has-spinner btn-'+buttonVariant+(spinnerActive ? ' active' : '')
    return (
        <button
            className={className}
            onClick={(e) => handleOnClick(e)}
            role="button"
        >
            <span className="psc-spinner"><i className="fa fa-refresh fa-spin fa-fw"></i></span>
            {label}
        </button>
    )
});

export default SaveButton
